/**
 * Возвращает текущее время для указанного смещения UTC (например "+03:00" или "-05:30").
 * @param {string} utcOffset - Смещение UTC.
 * @returns {Date|string} Объект Date с учётом смещения или пустая строка.
 */
function getCurrentTimeByOffset(utcOffset) {
  if (!utcOffset) return '';

  const now = new Date();

  // парсим смещение
  const sign = utcOffset.startsWith('-') ? -1 : 1;
  const [hoursStr, minutesStr = '0'] = utcOffset.replace(/[+-]/, '').split(':');
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  if (Number.isNaN(hours) || Number.isNaN(minutes)) return '';

  // текущее время в миллисекундах
  const utcMs = now.getTime() + now.getTimezoneOffset() * 60 * 1000;

  // добавляем нужное смещение
  const targetMs = utcMs + sign * (hours * 60 + minutes) * 60 * 1000;

  return new Date(targetMs);
}

export default getCurrentTimeByOffset;
